import Splide from "@splidejs/splide";
window.splide = Splide;

import { pointsGsap } from "../../includes/blocks/block-points-slider/script";
import { carsSlider } from "../../includes/blocks/block-cars-slider/script";
import { windowStickerGenerator } from "../../includes/blocks/block-window-sticker/script";

if (document.querySelectorAll(".blockPointsSlider")) {
	//   pointsSlider();
	pointsGsap();
}

if (document.querySelectorAll(".blockCarsSlider")) {
	carsSlider();
}

if (document.querySelector(".blockWindowSticker")) {
	windowStickerGenerator();
}

// Interactive SVG map
if (document.querySelector("#locationMap")) {
	const locationMap = document.querySelector("#locationMap");
	const contacts = locationMap.querySelectorAll(".contact-map");

	document.addEventListener("click", function (event) {
		if (event.target.matches(".location-map") || event.target.closest(".contact-map")) {
			if (event.target.matches(".location-map")) {
				event.preventDefault();
				const item = event.target;
				const itemId = item.getAttribute("data-contact");
				const itemContact = locationMap.querySelector(`#${itemId}`);

				contacts.forEach((el) => {
					el.classList.remove("contact-map--active");
				});

				itemContact.classList.add("contact-map--active");
			}
		} else {
			contacts.forEach((el) => {
				el.classList.remove("contact-map--active");
			});
		}
	}, false);
}